import { env } from './../../environments/env';

import { GoogleAuthService } from "./../google-auth.service";

import { DomSanitizer } from '@angular/platform-browser';
import { Component, ChangeDetectorRef, ViewChild, Inject, OnInit, ContentChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { AuthService } from '../services/auth.service';
import { Roles } from '../models/Roles';
import { } from '@angular/forms';

import { UploadDialogComponent } from "./../components/ui/uploaddialog/uploaddialog.component";
import { ConfirmationDialogComponent } from "./../components/ui/confirmation-dialog/confirmation-dialog.component";
import { ShowStudiesDialogComponent } from "./../components/ui/show-studies-dialog/show-studies-dialog.component";
import { NoteDialogComponent } from "../components/ui/note-dialog/note-dialog.component";
import { AllNotesDIalogComponent } from "../components/ui/all-notes-dialog/all-notes-dialog.component";

import * as firebase from 'firebase';

import { MDCList } from '@material/list';
import { MDCTextField } from '@material/textfield';
import {
  MatPaginator,
  MatTableDataSource,
  MatSnackBar,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatSort,
  // Sort
} from '@angular/material';
declare function require(name: string);

// export interface dataFile {
//   name: string,
//   type: string,
//   content: string,
//   date: string,
// }
@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.css']
})

export class UserprofileComponent implements OnInit {
  displayedColumns: string[] = ['select', 'fileName', 'ftype', 'fileDesc', 'fdate'];

  user: any;
  patient: any;
  fdesc: string;
  fdate: string;

  ftype: string;

  files: any[] = [];
  patientName: string;
  dfate: string;
  url: string;

  patientCaseId: string;
  fileName: string;
  sourceDescription: string;
  uid: string;
  fileDiag: any;
  currentFileOpen: any;

  patientIdDoc: string;
  currentFileIndex: number;
  upprog: number;
  patientUsers: any[] = [];
  shareUserEmail: string;
  noteDiag: any;
  currentNoteWriting: any;

  currentNoteTitle: any;
  currentFileNotes: any[] = [];
  allNotesDiag: any;
  currentViewingNote: any;
  currentViewingNoteTitle: any;
  allowUpload: boolean;
  allowAddNote: boolean;
  allowDeleteNote: boolean;
  deleteConfirm: any;
  allowShare: boolean;
  realRole: string;
  selectedFile: string;

  allowedExtensions: Array<string>;

  width: string;
  casename: string;
  height: string;

  storename: string
  datasetname: string

  // Table Data / Selection.
  selection = new SelectionModel<any>(true, []);
  filesTableDataSource = new MatTableDataSource([]);

  // dfilesArr: Array<dataFile> = [];
  createdUserForCurrentSignedInUser: string;
  allCreatedUsersByCurrentSignedInUser: string[];
  uploadTypes: any[] = []
  selectedUploadType = {}
  auth2: any;
  googleUser: any;
  healthcare: any;

  gcloud_projectname = 'nuagedx-dev';
  gcloud_location = 'us-central1';
  gapiClientLoad: Promise<number>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dragAndDropControl: boolean;
  allowFolderUpload: boolean;

  // sortedData: dataFile[]

  constructor(
    private gas: GoogleAuthService,
    public route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public auths: AuthService,
    public router: Router,
    public ref: ChangeDetectorRef,
    public dialogRef: MatDialogRef<UserprofileComponent>,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) { width, casename, height }
  ) {

    this.casename = casename;

    const list = new MDCList(document.querySelector('.mdc-list'));
    this.fileName = '';
    this.files = [];
    this.upprog = 0;
    this.shareUserEmail = '';
    this.allowUpload = true;
    this.allowAddNote = true;
    this.allowDeleteNote = true;
    this.allowShare = true;
    this.fdesc = '';
    this.fdate = this.getCurrentDate();
    this.ftype = '';
    this.auth2 = '';
    this.healthcare;
    this.storename = ''

    // this.sortedData = this.dfilesArr.slice();
  }

  ngOnInit() {

    this.gas.gapi_Load();


    this.gas.gapiHealthcare$.subscribe((value) => {
      this.healthcare = value;
    });

    this.filesTableDataSource.paginator = this.paginator;
    this.filesTableDataSource.sort = this.sort;

    this.auths.user.subscribe((user) => {
      if (user) {
        this.uid = user.uid;
        this.user = user;
        const db = firebase.firestore();
        document.getElementById('nuageMenu').style.display = 'block';
        this.getRole(user.uid).then((role: string) => {
          this.realRole = role;
          if (this.realRole === Roles.consultant) {
            this.allowUpload = false;
            this.allowAddNote = false;
            this.allowDeleteNote = false;
            this.allowShare = false;
          } else {
            this.allowUpload = true;
            this.allowAddNote = true;
            this.allowDeleteNote = true;
            this.allowShare = true;
          }
          this.getFilesForPatient();
        });

        db.collection('users').where('uid', '==', user.uid).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data().uid === user.uid) {
              this.createdUserForCurrentSignedInUser = doc.data().createdBy ? doc.data().createdBy : null;
              this.allCreatedUsersByCurrentSignedInUser = doc.data().createdUsers ? doc.data().createdUsers : null;
            }
          });
        });

      }
    });

    this.uploadTypes = [
      { id: '1', name: 'File' },
      { id: '2', name: 'Video' },
      { id: '3', name: 'DICOM Disk (medical images)' },
      { id: '4', name: 'Video Disk' },
      // { id: '5', name: 'DICOM File' },
    ];

    this.selectedUploadType = this.uploadTypes[0];

    this.getFilesForPatient();

    this.currentNoteWriting = new MDCTextField(document.querySelector('.notewriting'));
    this.currentNoteTitle = new MDCTextField(document.querySelector('.currentnotetitle'));
    this.currentViewingNote = new MDCTextField(document.querySelector('.noteviewing'));
    this.currentViewingNoteTitle = new MDCTextField(document.querySelector('.viewingtitle'));
    const shareUserInput = new MDCTextField(document.querySelector('.shareUserInput'));
  }

  async handleFileClick(event, element) {
    // TODO: Improve this hardcoded ftype case
    if (element.ftype === "DICOM Disk (medical images)") {
      event.preventDefault();
      const google_healthcare_ds_path = 'projects/' + this.gcloud_projectname + '/locations/' + this.gcloud_location + '/datasets/' + this.patient.caseName + '/dicomStores/' + element.storename;
      const studylisturl = env.config.ohifViewerURL + google_healthcare_ds_path;

      try {
        this.gapi_SearchForStudies(google_healthcare_ds_path, element.fileName)
          .then((res) => {
            this.openStudiesDialog(res, studylisturl);
          })
      } catch (err) {
        console.log('error 223:', err);
      }
    }
  }

  openStudiesDialog(studies: any, studylisturl: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: 'Dialog title',
      message: `Message`,
      studies: studies,
      studylisturl: this.sanitizer.bypassSecurityTrustUrl(studylisturl)
    }

    const dialogRef = this.dialog.open(ShowStudiesDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(val => {
      console.log('afterClosed');
    })
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  checkRow() {
    const numSelected = this.selection.selected.length;
    this.selection.clear();
  }

  closeShare() {
    const mdcDialog = require('@material/dialog');
    const MDCDialog = mdcDialog.MDCDialog;
    const MDCDialogFoundation = mdcDialog.MDCDialogFoundation;
    const util = mdcDialog.util;

    const dialog = new MDCDialog(document.querySelector('.sharediag'));
    dialog.close();
  }

  delete(selected: any) {
    const uidForDeletion = [];
    for (let i = 0; i < selected.length; i++) {
      console.log((selected[i].value));
      uidForDeletion.push(selected[i].value);
    }
    this.updateDBDelete(uidForDeletion);
  }

  deleteFromArray(element: any, array: any): any {
    const newarray = [];
    for (let i = 0; i < array.length; i++) {
      if (element !== array[i].email) {
        newarray.push(array[i]);
      }
    }
    return newarray;
  }

  downloadFile() {
    this.currentFileOpen = this.selection.selected[0];

    const storage = firebase.storage();
    const pathReference = storage.ref();
    pathReference.child(this.currentFileOpen.filePath).getDownloadURL().then(function (url) {
      this.currentFileLink = url;

      let a = document.createElement('a');
      a.target = '_blank';
      a.setAttribute('download', "download");
      a.href = url;
      a.click();
    }).catch(function (error) {
    });
  }

  deleteFile() {
    this.currentFileOpen = this.selection.selected[0];
    const db = firebase.firestore();
    db.collection('files').where('fileId', '==', this.currentFileOpen.fileId).get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        db.collection('files').doc(doc.id).update({
          forDelete: true
        }).then(() => {
          this.getFilesForPatient();
          this.snackBar.open('File Deleted', null, {
            duration: 5000,
          });
        });
      });
    });
  }

  deleteFiles(files: any[]): any[] {
    const db = firebase.firestore();
    let deletedFiles = [];
    files.forEach(file => {
      db.collection('files').where('fileId', '==', file.fileId).get()
        .then((snap) => {
          snap.forEach((doc) => {
            db.collection('files').doc(doc.id).delete().then(() => {
              deletedFiles.push(file.fileName);
            })
          });
        });
    })

    return deletedFiles;
  }

  getCurrentDate() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    return mm + '/' + dd + '/' + yyyy;
  }

  getFilesForPatient() {
    const caseName = this.casename;
    const db = firebase.firestore();
    db.collection('patients').where('caseName', '==', caseName).get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.patient = doc.data();
        this.patientName = this.patient.FirstName.charAt(0).toUpperCase() + this.patient.FirstName.slice(1) + ' ' +
          this.patient.LastName.charAt(0).toUpperCase() + this.patient.LastName.slice(1);
        this.patientCaseId = this.patient.LegalCaseId;
      });
    });

    this.getRole(this.uid).then((role: string) => {
      db.collection('files').where('belongsTo', '==', caseName).get().then((querySnapshot) => {
        this.files = [];
        querySnapshot.forEach((doc) => {
          const file = doc.data();

          const storage = firebase.storage();
          const pathReference = storage.ref();
          pathReference.child(file.filePath).getDownloadURL().then(function (url) {
            file.URL = url;
          }).catch(function (error) {
          });

          if (file.sharedUsers) {
            file.sharedUsers.forEach((sharedUser) => {
              if ((sharedUser.email === this.user.email) && file.forDelete === false) {
                this.files.push(file);
                // this.dfilesArr.push({ name: file.name, type: file.type, content: file.content, date: file.date })
              }
            });
          }
          if (file.forDelete === false && (this.patient.uidOfCreator === this.user.uid || doc.data().creator === this.user.uid || role === Roles.superUser ||
            (this.allCreatedUsersByCurrentSignedInUser && this.allCreatedUsersByCurrentSignedInUser.includes(doc.data().creator)) ||
            this.createdUserForCurrentSignedInUser === doc.data().creator && role !== Roles.consultant)) {
            this.files.push(file);
          }
        });
        // update datasource
        this.filesTableDataSource.data = this.files;
      });
      this.ref.detectChanges();
    });
  }

  getRole(uid: string) {
    const db = firebase.firestore();
    return new Promise((resolve) => {
      db.collection('users').where('uid', '==', uid).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          resolve(doc.data().role);
        });
      });
    });
  }

  goBack() {
    window.history.back();
  }

  // sortData(sort: Sort) {
  //   const data = this.dfilesArr.slice();
  //   if (!sort.active || sort.direction === '') {
  //     this.sortedData = data;
  //     return;
  //   }

  //   this.sortedData = data.sort((a, b) => {
  //     const isAsc = sort.direction === 'asc';
  //     switch (sort.active) {
  //       case 'name': return this.compare(a.name, b.name, isAsc);
  //       case 'type': return this.compare(a.type, b.type, isAsc);
  //       case 'content': return this.compare(a.content, b.content, isAsc);
  //       case 'date': return this.compare(a.date, b.date, isAsc);
  //       default: return 0;
  //     }
  //   });
  // }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  uploadDiconFile(storename: string, file: any) {
    console.log('Üploading');
    console.log({ storename, file });
  }


  gapi_createStore(name: string, dataset: string, status: number) {
    if (status === 200)
      return status;
    const nstorename = name.toLowerCase() || '';
    const google_healthcare_ds_path = 'projects/' + this.gcloud_projectname + '/locations/' + this.gcloud_location + '/datasets/' + dataset;

    return this.healthcare.projects.locations.datasets.dicomStores.create({
      "parent": google_healthcare_ds_path,
      "dicomStoreId": nstorename,
      "resource": {}
    }).then((response) => {
      console.log('Store created', response);
      return 200;
    }, (error: any) => {
      console.log('Store not created', error);
      return 0;
    });
  }

  gapi_getStoreName(storename: string, dataset: string, setexisting: number) {
    if (setexisting !== 200)
      return 0;

    const caseName = storename;
    const google_healthcare_ds_path = 'projects/' + this.gcloud_projectname + '/locations/' + this.gcloud_location + '/datasets/' + dataset + '/dicomStores/';

    return this.healthcare.projects.locations.datasets.dicomStores.get({
      "name": google_healthcare_ds_path + caseName
    }).then(() => {
      console.log("Store already exists.");
      return 200;
    }, () => {
      console.log("This store doesn't exist");
      return 0
    });
  }

  firebase_StoreDcm(storename: string, file: any, gapiCreateStore: any) {
    let file_path = 'dcmstore/' + storename + '/' + storename + '_' + file.name;
    var storageRef = firebase.storage().ref().child(file_path);
    return storageRef.put(file).then(
      () => 'gs://' + this.gcloud_projectname + '.appspot.com/' + file_path,
      (err) => {
        console.log('error placing the file');
        return 0
      });
  }

  async firebase_StoreDCM(datasetname: string, storename: string, file: any) {
    let file_path = `dcmstore/${datasetname}/${storename}/${storename}_${file.name}`;
    var storageRef = firebase.storage().ref().child(file_path);
    return storageRef.put(file)
      .then(
        // () => 'gs://' + this.gcloud_projectname + '.appspot.com/' + file_path,
        () => { console.log('File uploaded successfully') },
        (error) => { console.log('error placing the file', error); return 0 }
      )
  }

  async gapi_ImportDCIMs(dataset, storename) {
    console.log('gapi_ImportDCIM');
    const baseappurl = "nuagedx-dev.appspot.com"
    const gsuri = `gs://${baseappurl}/dcmstore/${dataset}/${storename}/*`

    const google_healthcare_ds_path = 'projects/' + this.gcloud_projectname + '/locations/' + this.gcloud_location + '/datasets/' + dataset + '/dicomStores/' + storename;
    const importObject = {
      "name": google_healthcare_ds_path,
      "resource": {
        "gcsSource": {
          "uri": gsuri
        }
      }
    };

    return this.healthcare.projects.locations.datasets.dicomStores.import(importObject)
      .then((res: any) => {
        this.snackBar.open('DICOM disc (medical images) imported successfully.', null, {
          duration: 5000,
        });
        return google_healthcare_ds_path;
      }, (err) => {
        this.snackBar.open('There was an error during the importing process.', null, {
          duration: 5000,
        });
        console.log('importDCIM - error', err);
        return 0;
      })
  }

  gapi_getSetName(setname: string, clientload: number) {
    if (clientload === 200) {
      const google_healthcare_ds_path = 'projects/' + this.gcloud_projectname + '/locations/' + this.gcloud_location + '/datasets/' + setname;
      return this.healthcare.projects.locations.datasets.get({ "name": google_healthcare_ds_path }).then(
        (res) => {
          console.log('res:', res);
          return 200;
        },
        (err) => {
          console.log('error 501:', err);
          return 0;
        });
    }
    else {
      console.log('client not loaded yet');
      return 0;
    }
  }

  async gapi_checkDataSet(setname: string, status: number) {
    if (status === 200)
      return 0;

    const google_healthcare_s_parent = 'projects/' + this.gcloud_projectname + '/locations/' + this.gcloud_location;
    return this.healthcare.projects.locations.datasets.get(
      {
        "name": google_healthcare_s_parent + '/datasets/' + setname,
      }
    )
      .then(() => {
        console.log('dataset exists');
        return 200;
      }, (err) => {
        console.log('dataset not exists');
        return 0;
      });
  }

  async gapi_createSet(setname: any, status: number) {
    if (status !== 200)
      return 0;

    const google_healthcare_s_parent = 'projects/' + this.gcloud_projectname + '/locations/' + this.gcloud_location;
    return this.healthcare.projects.locations.datasets.create({
      "parent": google_healthcare_s_parent,
      "datasetId": setname,
      "resource": {}
    }).then(() => {
      console.log('dataset created');
      return 200;
    }, (error) => {
      console.log('dataset not created:', error);
      return 0;
    });
  }

  // Import all dcm files into a single store.
  async gc_importDCMData_grouped() {
    console.log("gc_importDCMData_grouped");
  }

  // Import all dcm files (one store per dcm files).
  async gc_importDCMData_one2one() {
    console.log("gc_importDCMData_one2one");
  }

  async healthcareCreate(params) {
    this.datasetname = params.datasetname || ' ';
    console.log("healthcareCreate");
    const dataset = this.datasetname;
    const files = Array.from(params.files);
    console.log("FILES", files.length);
    const date = params.date;

    let gapiClientLoad;
    const isSignedIn = this.gas.GoogleAuth;
    if (!isSignedIn) {
      this.gas.gapi_ClientLoad().then(
        async (response) => {
          gapiClientLoad = 200;
          try {
            const gapiSetName = await this.gapi_getSetName(dataset, gapiClientLoad);
            const gapiCreateSet = await this.gapi_createSet(dataset, gapiSetName);
            const storeCreateImport = await this.storeImportDCMs_m(files, dataset, date, 200)
          } catch (error) { console.log('error', error) }
        })
    } else {
      gapiClientLoad = 200
      try {
        const gapiSetName = await this.gapi_getSetName(dataset, gapiClientLoad);
        const gapiCreateSet = await this.gapi_createSet(dataset, gapiSetName);
        const storeCreateImport = await this.storeImportDCMs_m(files, dataset, date, 200)
      } catch (error) {
        console.log('error', error);
      }
    }
  }

  generateStoreName(dataset: string, date: string) {
    const randNum = Math.floor(Math.random() * Math.floor(950));
    const storename = dataset + '_' + this.setDateToString(new Date(date)) + '_' + randNum
    this.storename = storename
    return storename;
  }

  async storeImportDCMs_m(files, dataset: string, date, gapiCreateSet) {
    console.log("files", files.length)
    const storename = this.generateStoreName(dataset, date)

    try {
      const gapiStoreName = await this.gapi_getStoreName(storename, dataset, gapiCreateSet);
      const gapiCreateStore = await this.gapi_createStore(storename, dataset, gapiStoreName);
    } catch (error) {
      console.log("error", error)
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const storeImportDCMs = await this.firebase_StoreDCM(this.datasetname, this.storename, file)
    }

    this.snackBar.open('DICOM disc (medical images) uploaded successfully.', null, {
      duration: 5000,
    });
    this.gapi_ImportDCIMs(dataset, storename)
  }

  gapi_GetStudies(url: string) {
    const searchObject = {
      parent: url,
      dicomWebPath: "series",
    };

    return this.healthcare.projects.locations.datasets.dicomStores
      .searchForSeries(searchObject)
      .then((d) => {
        console.log("d:", d.result);

        let list = [];
        d.result.forEach((object) => {
          for (const key in object) {
            if (object.hasOwnProperty(key)) {
              if (object[key].vr === "UI") {
                const viewerUrl = this.sanitizer.bypassSecurityTrustUrl(env.config.ohifViewerURL + url + '/study/' + object[key].Value[0]);
                list.push({
                  studyId: object[key].Value[0],
                  link: viewerUrl
                });
              }
            }
          }
        });
        return list;
      },
        (err: any) => {
          console.log('error:', err);
          return 0;
        });
  }

  gapi_SearchForStudies(url: string, dicomStore: string) {
    const searchObject = {
      parent: url,
      dicomWebPath: "studies",
    };
    return this.gapi_search4studies(searchObject, url)
  }

  gapi_search4studies(searchObject, url) {
    return this.healthcare.projects.locations.datasets.dicomStores.searchForStudies(searchObject)
      .then((d) => {
        let list = [];
        console.log('d.result', d.result);
        d.result.forEach((object: any) => {
          let key_vr = '';
          let st_viewerUrl;
          let studyId = '';
          let st_date = '';
          let st_patientName = '';
          let st_doctorName = '';

          for (const key in object) {
            if (object.hasOwnProperty(key)) {
              key_vr = object[key].vr;
              if (key_vr === "UI") {
                studyId = object[key].Value[0];
                st_viewerUrl = this.sanitizer.bypassSecurityTrustUrl(env.config.ohifViewerURL + url + '/study/' + studyId);
              }
              if (key_vr === "DA") {
                const objValue = object[key.toString()].Value;
                st_date = (key_vr === "DA" && objValue) ? object[key.toString()].Value[0] : st_date;
              }
              if (key_vr === "PN") {
                if (st_doctorName)
                  st_patientName = object[key.toString()].Value[0]['Alphabetic'];
                else
                  st_doctorName = object[key.toString()].Value[0]['Alphabetic'];
              }
            }
          }

          list.push({
            studyId: studyId,
            link: st_viewerUrl,
            date: st_date,
            doctorName: st_doctorName.replace('^', ' '),
            patientName: st_patientName.replace('^', ' ')
          });
        });

        console.log("LIST:", list);
        return list;
      },
        (err: any) => {
          console.log('error:', err);
          return 0;
        });
  }

  getDateToString(dateValue) {
    return dateValue.getDate().toString() + '/' + (dateValue.getMonth() + 1).toString() + '/' + dateValue.getFullYear().toString()
  }

  setDateToString(dateValue) {
    return dateValue.getDate().toString() + (dateValue.getMonth() + 1).toString() + dateValue.getFullYear().toString()
  }

  handleMultiFilesInput(params: any) {
    // TODO: Has to remove this hardcoded filetypes.
    let uploadTypes = [
      'none',
      'File',
      'Video',
      'DICOM Disk (medical images)',
      'Video Disk',
      // 'DICOM File',
    ];

    const storageRef = firebase.storage().ref();

    const db = firebase.firestore();
    const uploader = params.creator;
    const caseNameUpper = params.caseName;
    document.getElementById('progbar').style.display = 'block';
    let storecomplementname = this.getNewStoreName_complement(new Date(params.fdate).valueOf().toString())

    for (let i = 0; i < params.files.length; i++) {
      const file = params.files[i];
      const path = 'patient/' + this.patientCaseId + '/' + file.name;
      const store = storageRef.child(path);
      const dateValue = new Date(params.fdate);
      const dateString = this.getDateToString(dateValue);
      const utask = store.put(file);
      this.utaskRun(utask, db, path, params, file, dateString, uploader, uploadTypes, caseNameUpper, storecomplementname);
    }

    // If DICOM file.
    let dataSetName;

    switch (params.type) {
      case '1':
        this.allowFolderUpload = false
        break;
      case '2':
        this.allowFolderUpload = false
        break;
      case '3':
        console.log('You choosed DICOM Disk');
        this.dragAndDropControl = true;
        dataSetName = this.patient.caseName;
        this.allowFolderUpload = true
        this.healthcareCreate({
          datasetname: dataSetName,
          files: params.files,
          date: params.fdate,
          storecomplementname
        });
        break;
      case '4':
        console.log('You choosed VIDEO Disk');
        this.dragAndDropControl = true
        this.allowedExtensions = env.config.allowedExtensions.video
        this.allowFolderUpload = true
        break;
      case '5':
        console.log('You choosed DICOM File');
        this.allowedExtensions = env.config.allowedExtensions.files;
        this.allowFolderUpload = false
        dataSetName = this.patient.caseName;
        this.healthcareCreate({
          datasetname: dataSetName,
          files: params.files,
          date: params.fdate
        });
        break;
      default:
        break;
    }
  }

  getNewStoreName(filename: string, date: string) {
    const randNum = Math.floor(Math.random() * Math.floor(950));
    // TODO: save this storename in firebase.
    return filename + '_' + date + '_' + randNum;
    // return filename;
  }

  getNewStoreName_complement(date: string) {
    const randNum = Math.floor(Math.random() * Math.floor(950));
    // TODO: save this storename in firebase.
    return '_' + date + '_' + randNum;
    // return filename;
  }

  getNewSetName(caseName: string, date: string) {
    const randNum = Math.floor(Math.random() * Math.floor(950));
    return caseName + '_' + date + '_' + randNum;
  }

  utaskRun(
    utask: firebase.storage.UploadTask,
    db: firebase.firestore.Firestore,
    path: string,
    params: { desc: any; type: string | number; },
    file: { name: any; },
    dateString: string,
    uploader: any,
    uploadTypes: string[],
    caseNameUpper: string,
    storecomplementname: string
  ) {
    utask.then((snapshot) => {
      db.collection('files').add({
        belongsTo: caseNameUpper,
        creator: uploader,
        fileDesc: params.desc,
        fileId: new Date().getTime().toString() + caseNameUpper,
        fileName: file.name,
        filePath: path,
        fdate: dateString,
        forDelete: false,
        ftype: uploadTypes[params.type],
        notes: [],
        storename: file.name + storecomplementname,
        viewerurl: 'http://www.viewerurl'
      }).then(() => {
        this.writeFileSearchQueryToPatient()
        this.getFilesForPatient()
      });
    });

    utask.on('state_changed', (snapshot) => {
      this.upprog = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

      if (this.upprog === 100) {
        document.getElementById('progbar').style.display = 'none';
      }
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.files.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.files.forEach(row => this.selection.select(row));
  }

  noteSave(noteFile, noteObject) {
    console.log("Add Note:", noteFile);
    console.log("Note Object:", noteObject);

    noteFile.notes.push({
      noteTitle: noteObject.name,
      note: noteObject.description,
      createdBy: noteObject.useremail
    });

    const db = firebase.firestore();

    db.collection('files').where('fileId', '==', noteFile.fileId).get().then((fileSnapshot) => {
      fileSnapshot.forEach((file) => {
        const filePayload = file.data();
        db.collection('files').doc(file.id).update({
          notes: firebase.firestore.FieldValue.arrayUnion({
            noteTitle: noteObject.name,
            note: noteObject.description,
            createdBy: noteObject.useremail
          })
        }).then(() => {
          this.snackBar.open('Notes Added Successfully', null, {
            duration: 5000,
          });
          return 'Note Added Successfully'
        }).catch((error) => {
          this.snackBar.open(error.message, null, {
            duration: 5000,
          });
          return error.message
        });
      });
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    this.dialog.openDialogs.pop();

    dialogConfig.minWidth = 300
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      id: 1,
      uploadTypes: [
        { id: '1', name: 'File' },
        { id: '2', name: 'Video' },
        { id: '3', name: 'DICOM Disk (medical images)' },
        { id: '4', name: 'Video Disk' },
        // { id: '5', name: 'DICOM File' },
      ],
      fdate: this.fdate,
      basicfile: this.files,
      description: this.fdesc,
      type: this.ftype,
      action_params: { files: '', type: '', desc: '', caseName: this.patient.caseName, creator: this.uid }
    }

    const dialogRef = this.dialog.open(UploadDialogComponent, dialogConfig);
    const subs = dialogRef.componentInstance.onFinish.subscribe(
      (data: any) => {
        this.handleMultiFilesInput(data)
      }
    )

    dialogRef.keydownEvents().subscribe(e => {
      if (e.keyCode === 27) {
        e.preventDefault();
        dialogRef.close();
      }
    })

    dialogRef.afterClosed().subscribe(() => subs.unsubscribe());
    // dialogRef.afterClosed().subscribe(() => subsFile.unsubscribe());
  }

  openDeleteConfirmDialog() {
    const dialogConfig = new MatDialogConfig();

    let files: string = '';
    let word: string = this.selection.selected.length > 1 ? 'these' : 'this';
    this.selection.selected.forEach((e) => {
      files += `<li class="mat-list-item">${e.fileName}</li>`
    })
    files = `<ul class="mat-list" role="list">${files}</ul>`

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: 'Confirm Deletion',
      message: `Are you sure  you want to delete ${word}: ${files}`,
      confirm_action: this.deleteFiles,
      selected_files: this.selection.selected
    }

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(val => {
      console.log('Dialog output:', val);
      this.selection.clear()
      this.getFilesForPatient()
    })
  }

  openHelp() {
    this.url = 'https://www.merriam-webster.com/dictionary/help';
    window.open(this.url, "_blank");
  }

  openShare() {
    this.patientUsers = [];
    this.currentFileOpen = this.selection.selected;
    this.currentFileOpen = this.selection.selected[0];
    this.currentFileOpen = this.selection.selected[0];
    this.selection.selected.forEach((selected) => {
      if (selected.sharedUsers) {
        this.patientUsers.push(...selected.sharedUsers);
      }
    });
    const mdcDialog = require('@material/dialog');
    const MDCDialog = mdcDialog.MDCDialog;
    const MDCDialogFoundation = mdcDialog.MDCDialogFoundation;
    const util = mdcDialog.util;

    const dialog = new MDCDialog(document.querySelector('.sharediag'));
    dialog.open();
  }

  openFileDiag(file: any) {
    this.currentFileOpen = file[0];

    for (let i = 0; i < this.files.length; i++) {
      if (this.files[i] === this.currentFileOpen) {
        this.currentFileIndex = i;
      }
    }

    const mdcDialog = require('@material/dialog');
    const MDCDialog = mdcDialog.MDCDialog;
    const MDCDialogFoundation = mdcDialog.MDCDialogFoundation;
    const util = mdcDialog.util;

    this.fileDiag = new MDCDialog(document.querySelector('.fileinfo'));

    this.fileDiag.open();
  }

  openAddNoteDialog() {
    let selectedFile = this.selection.selected[0];

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: 'Add Note',
      message: `Please add a note for ${selectedFile.name} here:`,
      confirm_action: this.noteSave,
      selected_file: this.selection.selected[0],
      useremail: this.user.email,
      name: '',
      description: ''
    }

    const dialogRef = this.dialog.open(NoteDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(val => {
      console.log('Dialog output:', val);
      this.selection.clear()
      this.getFilesForPatient()
    })

  }

  openAddDateDialog() {
    const mdcDialog = require('@material/dialog');
    const MDCDialog = mdcDialog.MDCDialog;
    const MDCDialogFoundation = mdcDialog.MDCDialogFoundation;
    const util = mdcDialog.util;
    if (this.allNotesDiag) {
      this.allNotesDiag.close();
    }
    this.noteDiag = new MDCDialog(document.querySelector('.adddate'));
    this.noteDiag.open();
  }

  openAddFileDialog() {
    const mdcDialog = require('@material/dialog');
    const MDCDialog = mdcDialog.MDCDialog;
    const MDCDialogFoundation = mdcDialog.MDCDialogFoundation;
    const util = mdcDialog.util;
    if (this.allNotesDiag) {
      this.allNotesDiag.close();
    }
    this.noteDiag = new MDCDialog(document.querySelector('.addFile'));
    this.noteDiag.open();
  }

  openAddNoteDialogForView(note: any) {
    const mdcDialog = require('@material/dialog');
    const MDCDialog = mdcDialog.MDCDialog;
    const MDCDialogFoundation = mdcDialog.MDCDialogFoundation;
    const util = mdcDialog.util;
    if (this.allNotesDiag) {
      this.allNotesDiag.close();
    }
    this.currentViewingNoteTitle.value = note.noteTitle;
    this.currentViewingNote.value = note.note;
    this.noteDiag = new MDCDialog(document.querySelector('.viewnote'));
    this.noteDiag.open();
  }

  openAllNotes() {
    const dialogConfig = new MatDialogConfig();

    let files: string = '';
    let word: string = this.selection.selected.length > 1 ? 'these' : 'this';
    this.selection.selected.forEach((e, i) => {
      files += `<li class="mat-list-item">${e.fileName}</li>`
    })

    files = `<ul class="mat-list" role="list">${files}</ul>`

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: 'View Notes',
      message: `These are the notes for ${files}`,
      selected_files: this.selection.selected,
      notes: this.selection.selected[0].notes,
    }

    const dialogRef = this.dialog.open(AllNotesDIalogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(val => {
      console.log('Dialog output:', val);
      this.selection.clear()
      this.getFilesForPatient()
    })
  }

  showSnackBar(message: string, config: object) {
    this.snackBar.open(message, null, config)
  }

  shareFile() {
    let selectedFiles = this.selection.selected;
    const db = firebase.firestore();
    db.collection('users').where('email', '==', this.shareUserEmail).get().then((querySnapshot) => {
      const userSharingWith =
        querySnapshot.forEach((doc) => {
          const userSharingWith = doc.data();
          for (let i = 0; i < selectedFiles.length; i++) {
            db.collection('files').where('fileId', '==', selectedFiles[i].fileId).get().then((querySnapshot2) => {
              // tslint:disable-next-line: no-shadowed-variable
              querySnapshot2.forEach((doc2) => {
                const file = doc2.data();
                if (file.sharedUsers) {
                  db.collection('files').doc(doc2.id).update({
                    sharedUsers: firebase.firestore.FieldValue.arrayUnion({ email: this.shareUserEmail, name: userSharingWith.name })
                  }).then(() => {
                    this.updateUserSharedWith(file, userSharingWith.name);
                  })
                } else {
                  db.collection('files').doc(doc2.id).update(
                    {
                      sharedUsers: [{ email: this.shareUserEmail, name: userSharingWith.name }]
                    }
                  ).then(() => {
                    this.updateUserSharedWith(file, userSharingWith.name);
                  });
                }
              });
            });
          }
        });
    });
  }

  saveNote() {
    this.currentFileOpen.notes.push({
      note: this.currentNoteWriting.value, noteTitle: this.currentNoteTitle.value,
      createdBy: this.user.email
    });

    this.files[this.currentFileIndex] = this.currentFileOpen;

    const db = firebase.firestore();

    db.collection('files').where('fileId', '==', this.currentFileOpen.fileId).get().then((fileSnapshot) => {
      fileSnapshot.forEach((file) => {
        const filePayload = file.data();
        db.collection('files').doc(file.id).update({
          notes: firebase.firestore.FieldValue.arrayUnion({
            note: this.currentNoteWriting.value,
            noteTitle: this.currentNoteTitle.value,
            createdBy: this.user.email
          })
        }).then(() => {
          this.snackBar.open('Notes Added Successfully', null, {
            duration: 5000,
          });
          this.currentNoteTitle.value = '';
          this.currentNoteWriting.value = '';
        }).catch((error) => {
          this.snackBar.open(error.message, null, {
            duration: 5000,
          });
        });
      });
    });
  }

  saveDate() {
    const dateValue = new Date(this.fdate);
    const dateString = dateValue.getDate().toString() + '/' + (dateValue.getMonth() + 1).toString() + '/' + dateValue.getFullYear().toString();
    this.currentFileOpen.notes.push({
      note: dateString, noteTitle: 'Date Of File',
      createdBy: this.user.email
    });

    this.files[this.currentFileIndex] = this.currentFileOpen;

    const db = firebase.firestore();

    db.collection('files').where('fileId', '==', this.currentFileOpen.fileId).get().then((fileSnapshot) => {
      fileSnapshot.forEach((file) => {

        db.collection('files').doc(file.id).update({
          "fdate": dateString


        }).then(() => {
          this.snackBar.open('Date Added Successfully', null, {
            duration: 5000,
          });
          this.currentNoteTitle.value = '';
          this.currentNoteWriting.value = '';
        }).catch((error) => {
          this.snackBar.open(error.message, null, {
            duration: 5000,
          });
        });
      });
    });
  }

  updateUserSharedWith(file: any, userSharedWithName) {
    const db = firebase.firestore();

    db.collection('users').where('email', '==', this.shareUserEmail).get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        db.collection('users').doc(doc.id).update({
          filesSharedWith: doc.data().filesSharedWith ? firebase.firestore.FieldValue.arrayUnion(
            { fileId: file.fileId, patientCaseName: this.patient.caseName }) :
            [{ fileId: file.fileId, patientCaseName: this.patient.caseName }]
        }).then(() => {
          this.snackBar.open('File Shared with ' + userSharedWithName, null, { duration: 1500 });
          document.getElementById('shareDiagNo').click();
          this.getFilesForPatient();
          this.selection.clear();
        }).catch((error) => {
        });
      });
    });
  }

  updateDBDelete(emailsForDeletion: any[]) {
    let currentFile = this.selection.selected[0];
    const db = firebase.firestore();
    emailsForDeletion.forEach((item) => {
      db.collection('files').where('fileId', '==', currentFile.fileId).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          db.collection('files').doc(doc.id).update({
            sharedUsers: firebase.firestore.FieldValue.arrayRemove(item)
          }).then(() => {
            db.collection('users').where('email', '==', item.email).get().then((querySnapshot2) => {
              querySnapshot2.forEach((doc2) => {
                db.collection('users').doc(doc2.id).update({
                  filesSharedWith: firebase.firestore.FieldValue.arrayRemove({
                    fileId: currentFile.fileId,
                    patientCaseName: this.casename
                  })
                }).then(() => {
                  this.snackBar.open('Shared permission revoked', null, {
                    duration: 5000,
                  });
                  document.getElementById('shareDiagNo').click();
                  this.currentFileOpen = undefined;
                  this.getFilesForPatient();
                  this.selection.clear();
                }).catch((error) => {
                  this.snackBar.open(error.message, null, {
                    duration: 5000,
                  });
                });
              });
            });
          });
        });
      });
    });
  }

  writeFileSearchQueryToPatient() {
    const db = firebase.firestore();
    const caseName = this.patient.caseName;
    db.collection('patients').where('caseName', '==', caseName).get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        db.collection('patients').doc(caseName).update({
          fileSearchQuery: firebase.firestore.FieldValue.arrayUnion(
            new Date().getTime().toString() + caseName
          )
        }).then(() => {
          this.snackBar.open('File Uploaded', null, {
            duration: 5000,
          });
        }).catch((error) => {
          this.snackBar.open('Error uploading file ' + error.message, null, {
            duration: 5000,
          });
        });
      });
    });
  }
}
